require("org/roster_upload/roster_upload_progress_meter.scss");

var RosterUploadPogressMeter = function(props) {

	var stagesNames = [
		"Upload File", "Verify Columns", "Verify Grades",
		"Verify Classes", "Confirm"
	];

	var stages = [];

	for (var i = 0; i < stagesNames.length; i++) {
		var className = "stage";
		if (props.index == i) {
			className += " current";
		} else if (props.index > i) {
			className += " past";
		}

		stages.push(
			<span className={ className } key={ i }>
				<span className="stageNumber">{ i + 1 }</span>
				<span className="stageName">{ stagesNames[i] }</span>
			</span>
		);
	}

	return (
		<div className="rosterUploadProgressMeter clearfix">
			{ stages }
		</div>
	)
}

RosterUploadPogressMeter.propTypes = StrictPropTypes({
	index: PropTypes.number.isRequired
});

module.exports = RosterUploadPogressMeter;


// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadProgressMeter.js